<template>
  <RoundTable v-if="$store.state.familyList['shop/manuka'] != undefined"/>
</template>

<script>
import RoundTable from '../components/RoundTable.vue'
export default {
  components: {
    RoundTable
  }
}
</script>

<style>
</style>